import { FC } from 'react'
import { useSelector } from 'react-redux'
import RootState from '../../../../redux/types'
import { FilterSectionTransport } from '../../../../transports/search-result-listing-static-transport'
import { getUserDetailsModel } from '../../../../redux/user/selectors'
import {
    HeaderRow,
    MobileWishlistButton,
    PillWrapper,
    WishlistBadge,
    WishlistIconStyled,
    WishlistIconContainer,
} from './styles'
import FilterPill from '../../../app-components/filter-components/filter-pill'
import SortPill from '../../../app-components/filter-components/sort-pill'
import ButtonTransport from '../../../../transports/common/button-transport'

interface Props {
    filterStaticData: FilterSectionTransport
    wishlistButton?: ButtonTransport
}

const FilterHeader: FC<Props> = ({ filterStaticData, wishlistButton }) => {
    const userDetails = useSelector(getUserDetailsModel)
    const reduxWishlistCount = useSelector((state: RootState) => state.wishlist.count)
    const wishlistCount = reduxWishlistCount ?? userDetails?.favoriteCount ?? 0

    return (
        <HeaderRow>
            <PillWrapper>
                <SortPill filterStaticData={filterStaticData} />
                <FilterPill filterStaticData={filterStaticData} />
            </PillWrapper>
            {!!wishlistButton?.url && (
                <MobileWishlistButton href={wishlistButton.url} noCrawl={wishlistButton.noCrawl}>
                    <WishlistIconContainer>
                        <WishlistIconStyled />
                        {wishlistCount > 0 && <WishlistBadge>{wishlistCount}</WishlistBadge>}
                    </WishlistIconContainer>
                </MobileWishlistButton>
            )}
        </HeaderRow>
    )
}

export default FilterHeader
